import { BRAND_COLORS } from '@/components/utils/constants';

const ProfileEditIcon = ({
	fill = BRAND_COLORS.PURPLE_500,
}: {
	fill?: string;
}) => {
	return (
		<svg
			width="20"
			height="19"
			viewBox="0 0 20 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.99997 18H19M1 18H2.67454C3.16372 18 3.40832 18 3.63849 17.9447C3.84256 17.8957 4.03765 17.8149 4.2166 17.7053C4.41843 17.5816 4.59138 17.4086 4.93729 17.0627L17.5 4.49998C18.3285 3.67156 18.3285 2.32841 17.5 1.49998C16.6716 0.671555 15.3285 0.671556 14.5 1.49998L1.93726 14.0627C1.59136 14.4086 1.4184 14.5816 1.29472 14.7834C1.18506 14.9624 1.10425 15.1574 1.05526 15.3615C1 15.5917 1 15.8363 1 16.3255V18Z"
				stroke={fill}
			/>
		</svg>
	);
};

const ProfileCancelIcon = ({
	fill = BRAND_COLORS.PURPLE_500,
}: {
	fill?: string;
}) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.68 18L12 13.68L16.32 18L18 16.32L13.68 12L18 7.68L16.32 6L12 10.32L7.68 6L6 7.68L10.32 12L6 16.32L7.68 18ZM12 24C10.34 24 8.78 23.6848 7.32 23.0544C5.86 22.424 4.59 21.5692 3.51 20.49C2.43 19.4108 1.5752 18.1408 0.945601 16.68C0.316001 15.2192 0.000801518 13.6592 1.51899e-06 12C-0.00079848 10.3408 0.314401 8.7808 0.945601 7.32C1.5768 5.8592 2.4316 4.5892 3.51 3.51C4.5884 2.4308 5.8584 1.576 7.32 0.9456C8.7816 0.3152 10.3416 0 12 0C13.6584 0 15.2184 0.3152 16.68 0.9456C18.1416 1.576 19.4116 2.4308 20.49 3.51C21.5684 4.5892 22.4236 5.8592 23.0556 7.32C23.6876 8.7808 24.0024 10.3408 24 12C23.9976 13.6592 23.6824 15.2192 23.0544 16.68C22.4264 18.1408 21.5716 19.4108 20.49 20.49C19.4084 21.5692 18.1384 22.4244 16.68 23.0556C15.2216 23.6868 13.6616 24.0016 12 24ZM12 21.6C14.68 21.6 16.95 20.67 18.81 18.81C20.67 16.95 21.6 14.68 21.6 12C21.6 9.32 20.67 7.05 18.81 5.19C16.95 3.33 14.68 2.4 12 2.4C9.31999 2.4 7.05 3.33 5.19 5.19C3.33 7.05 2.4 9.32 2.4 12C2.4 14.68 3.33 16.95 5.19 18.81C7.05 20.67 9.31999 21.6 12 21.6Z"
				fill={fill}
			/>
		</svg>
	);
};

export { ProfileEditIcon, ProfileCancelIcon };
